import { render, staticRenderFns } from "./Pwchange.vue?vue&type=template&id=1904cafa&scoped=true"
import script from "./Pwchange.vue?vue&type=script&lang=js"
export * from "./Pwchange.vue?vue&type=script&lang=js"
import style0 from "./Pwchange.vue?vue&type=style&index=0&id=1904cafa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1904cafa",
  null
  
)

export default component.exports